export default "__VITE_ASSET__7ce2364d__"